<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >{{title}}</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(getData)">
          <p class="description">* Silahkan masukan NOP yang ingin dicari objek pajak nya.</p>
          <div class="mb-5">
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <ValidationProvider name="NOP" rules="required" v-slot="{ errors }">
                  <base-input
                    placeholder="NOP"
                    v-model="form.nop"
                    :required="true"
                    :error="errors[0]"
                    :valid="(errors[0] !== null && errors[0] !== '')"
                  ></base-input>
                </ValidationProvider>
              </div>
              <div class="col-lg-4 col-sm-6">
                <base-button type="success" nativeType="submit" icon="ni ni-zoom-split-in">Cari Data</base-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <hr />
      <b-table
        :bordered="true"
        :small="true"
        :hover="true"
        :items="items"
        :fields="fields"
        :head-variant="'light'"
        :busy.sync="isBusy"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <template slot="footer">
      <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { BTable, BTr, BTh } from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import dateToDateHumanize from "@/plugins/dateFormater";
import formatToMoney from "@/plugins/formatToMoney";
import mapInvestigationType from "@/plugins/mapInvestigationType";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    Modal,
    BTable,
    PulseLoader,
    BTr,
    BTh,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal"
    },
    code: {
      type: String,
      description: "Code Pajak"
    },
    url: {
      type: String,
      description: "Url Pajak"
    }
  },
  data() {
    return {
      modals: {
        modal1: false
      },
      form: {
        nop: null
      },
      fields: [
        {
          key: "tgl_serah_berkas",
          sortable: false,
          label: "Tanggal Serah Berkas",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "nama",
          sortable: false,
          label: "Nama Wajib Pajak",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "alamat",
          sortable: false,
          label: "Alamat Wajib Pajak",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "nilai_transaksi",
          sortable: false,
          label: "Nilai Transaksi",
          class: "text-right",
          thClass: "text-center",
          formatter: function(value) {
            return formatToMoney(value);
          }
        },
        {
          key: "bphtb",
          sortable: false,
          label: "Denda",
          class: "text-right",
          thClass: "text-center",
          formatter: function(value) {
            return formatToMoney(value);
          }
        },
        {
          key: "tgl_bayar",
          sortable: false,
          label: "Tanggal Serah Berkas",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "jml_bayar",
          sortable: false,
          label: "Jumlah Bayar",
          class: "text-right",
          thClass: "text-center",
          formatter: function(value) {
            return formatToMoney(value);
          }
        },
        {
          key: "jenis_prh",
          sortable: false,
          label: "Jenis Transaksi",
          class: "text-center",
          thClass: "text-center"
        },
        {
          key: "nama_ppat",
          sortable: false,
          label: "PPAT",
          class: "text-left",
          thClass: "text-center"
        }
      ],
      items: [],
      isBusy: false
    };
  },
  methods: {
    showModal() {
      this.items = [];
      this.form.nop = "";
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async getData() {
      try {
        this.isBusy = true;
        let { data } = await axios.get(this.url + "?nop=" + this.form.nop);
        this.items = data;
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!"
        });
      } finally {
        this.isBusy = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}
</style>